module.exports = __webpack_public_path__ + "media/money-drop.18f6a294.mp3";